import { jsxs as r, jsx as e, Fragment as o } from "react/jsx-runtime";
import { c as h } from "./tw-cn-mXgPecoF.mjs";
import { R as m } from "./rectangle-button-7EcaVrM8.mjs";
const p = ({ icon: l, title: a, description: t, buttons: c, pcType: n = "pcSize" }) => {
  const d = n === "pcLegacySize";
  return /* @__PURE__ */ r("div", { className: "flex max-w-[360px] flex-col items-center p-32", children: [
    !!l && /* @__PURE__ */ e("div", { className: "mb-12", children: /* @__PURE__ */ e(l, { className: "text-fill-neutral-weak4" }) }),
    /* @__PURE__ */ r("div", { className: "flex flex-col items-center", children: [
      /* @__PURE__ */ e("div", { className: "text-center text-text-neutral-main typography-subtitle-16-regular", children: a }),
      !!t && (typeof t == "string" ? /* @__PURE__ */ e("div", { className: "mt-4 text-center text-text-neutral-sub typography-body-14-regular", children: t }) : /* @__PURE__ */ e(o, { children: t }))
    ] }),
    !!(c != null && c.length) && /* @__PURE__ */ e("div", { className: "mt-16 flex flex-col", children: c.map((s, i) => /* @__PURE__ */ e(
      m,
      {
        className: h("w-full min-w-180", {
          "last:mt-8": i !== 0
        }),
        onClick: s.onClick,
        size: {
          pc: d ? "medium" : "large"
        },
        theme: i === 0 ? "outlined_secondary" : "outlined_basic",
        weight: "bold",
        children: s.content
      },
      i
    )) })
  ] });
};
p.displayName = "NDS.EmptyState";
const x = ({ title: l, button: a }) => /* @__PURE__ */ r("div", { className: "flex flex-row items-center justify-between gap-8 py-4", children: [
  /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e("div", { className: "text-left text-text-neutral-main typography-body-14-regular", children: l }) }),
  !!a && /* @__PURE__ */ e("div", { className: "max-w-[50%] shrink-0", children: /* @__PURE__ */ e(m, { className: "", onClick: a.onClick, size: "small", theme: "outlined_secondary", weight: "bold", children: a.content }) })
] });
x.displayName = "NDS.EmptyStateBanner";
export {
  p as E,
  x as a
};
